import { render, staticRenderFns } from "./BdChat.vue?vue&type=template&id=30e2fbf6&"
import script from "./BdChat.vue?vue&type=script&lang=js&"
export * from "./BdChat.vue?vue&type=script&lang=js&"
import style0 from "./BdChat.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports